module.exports = __webpack_public_path__ + "img/pingtai0345.92c8af42.png";